import { Link } from "react-router-dom";
import Badge from "../ui/Badge";

function PostCard({ post }) {
  return (
    <article className="glass-card post-card">
      <div className="card-image">
        {post.coverImage ? (
          <img
            className="card-media-image"
            src={post.coverImage}
            alt={post.cover || post.title}
            loading="lazy"
          />
        ) : (
          <p>{post.cover}</p>
        )}
      </div>

      <div className="card-copy">
        <div className="meta-row">
          <Badge>{post.category}</Badge>
          <span className="meta-text">{post.readingTime}</span>
          <span className="meta-text">
            {new Date(post.publishedAt).toLocaleDateString("tr-TR")}
          </span>
        </div>
        <h3>{post.title}</h3>
        <p>{post.excerpt}</p>
      </div>

      <div className="tag-row">
        {post.tags.map((item) => (
          <span key={item} className="tag-pill">
            {item}
          </span>
        ))}
      </div>

      <div className="card-actions">
        <Link className="button button-secondary" to={`/blog/${post.slug}`}>
          Yaziyi Ac
        </Link>
      </div>
    </article>
  );
}

export default PostCard;
